(() => {
  const root = document.querySelector('[data-rv-booker]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const trigger = root.querySelector('[data-rv-booker-trigger]');
  const panel = root.querySelector('[data-rv-booker-panel]');
  const close = root.querySelector('[data-rv-booker-close]');
  const status = root.querySelector('[data-rv-booker-status]');
  const monthLabel = root.querySelector('[data-rv-booker-month]');
  const days = root.querySelector('[data-rv-booker-days]');
  const dateStep = root.querySelector('[data-rv-booker-step="date"]');
  const formatStep = root.querySelector('[data-rv-booker-step="format"]');
  const dateLabel = root.querySelector('[data-rv-booker-date]');
  const progress = root.querySelector('[data-rv-booker-progress]');
  const submit = root.querySelector('[data-rv-booker-submit]');
  const formats = [...root.querySelectorAll('[data-rv-booker-format]')];
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  let cursor = new Date(today.getFullYear(), today.getMonth(), 1);
  const firstMonth = new Date(cursor);
  const lastMonth = new Date(today.getFullYear(), today.getMonth() + 5, 1);
  let blocked = new Set();
  let verified = false;
  let selectedDate = '';
  let selectedFormat = '';

  const updateSubmitLabel = () => {
    if (!selectedFormat) {
      submit.textContent = 'Choose a visit type';
      return;
    }
    const format = selectedFormat === 'virtual' ? 'a virtual walkthrough' : 'an in-person visit';
    submit.textContent = `Reserve ${format} · ${root.dataset.priceLabel}`;
  };

  const resolveProduct = async () => {
    if (/^\d+$/.test(root.dataset.product || '')) return root.dataset.product;
    const handle = root.dataset.productHandle;
    if (!handle) return '';
    try {
      const shopRoot = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${shopRoot}products/${handle}.js`, { cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) return '';
      const product = await response.json();
      if (product.handle !== handle || product.variants?.length !== 1 || !product.variants[0].available) return '';
      const variant = String(product.variants[0].id || '');
      if (!/^\d+$/.test(variant)) return '';
      root.dataset.product = variant;
      return variant;
    } catch {
      return '';
    }
  };

  const iso = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  const openPanel = () => { panel.hidden = false; trigger.setAttribute('aria-expanded', 'true'); close.focus(); };
  const closePanel = () => { panel.hidden = true; trigger.setAttribute('aria-expanded', 'false'); trigger.focus(); };
  const showStep = step => {
    const isFormat = step === 'format';
    dateStep.hidden = isFormat;
    formatStep.hidden = !isFormat;
    progress.textContent = isFormat ? '2 / 2' : '1 / 2';
    root.querySelector('#rv-booker-title').textContent = isFormat ? 'Choose how to visit.' : 'Choose a flight date.';
  };
  const render = () => {
    monthLabel.textContent = cursor.toLocaleDateString(undefined, { month: 'long', year: 'numeric' });
    root.querySelector('[data-rv-booker-prev]').disabled = cursor <= firstMonth;
    root.querySelector('[data-rv-booker-next]').disabled = cursor >= lastMonth;
    days.replaceChildren();
    for (let index = 0; index < cursor.getDay(); index += 1) {
      const blank = document.createElement('span');
      blank.className = 'rv-booker__day is-empty';
      days.append(blank);
    }
    const count = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 0).getDate();
    for (let day = 1; day <= count; day += 1) {
      const date = new Date(cursor.getFullYear(), cursor.getMonth(), day);
      const key = iso(date);
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'rv-booker__day';
      button.textContent = day;
      button.disabled = !verified || date < today || date.getDay() === 0 || blocked.has(key);
      button.setAttribute('aria-label', date.toLocaleDateString(undefined, { dateStyle: 'full' }));
      button.setAttribute('aria-pressed', String(selectedDate === key));
      button.addEventListener('click', () => {
        selectedDate = key;
        dateLabel.textContent = date.toLocaleDateString(undefined, { dateStyle: 'long' });
        showStep('format');
        formats[0].focus();
        render();
      });
      days.append(button);
    }
  };
  const load = async () => {
    const api = root.dataset.api;
    const product = await resolveProduct();
    if (!api || !product) {
      status.textContent = 'Booking is not open yet. Visit the flight experience page for contact details.';
      render();
      return;
    }
    const end = new Date(today.getFullYear(), today.getMonth() + 6, 0);
    const separator = api.includes('?') ? '&' : '?';
    try {
      const response = await fetch(`${api}${separator}from=${iso(today)}&to=${iso(end)}`, { cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error();
      const payload = await response.json();
      blocked = new Set(payload.blockedDates || []);
      verified = true;
      status.textContent = 'Current availability loaded. Sundays are unavailable.';
    } catch {
      status.textContent = 'Availability could not be confirmed. Booking is temporarily unavailable.';
    }
    render();
  };

  trigger.addEventListener('click', () => panel.hidden ? openPanel() : closePanel());
  close.addEventListener('click', closePanel);
  root.querySelector('[data-rv-booker-back]').addEventListener('click', () => showStep('date'));
  root.querySelector('[data-rv-booker-prev]').addEventListener('click', () => { if (cursor > firstMonth) cursor.setMonth(cursor.getMonth() - 1); render(); });
  root.querySelector('[data-rv-booker-next]').addEventListener('click', () => { if (cursor < lastMonth) cursor.setMonth(cursor.getMonth() + 1); render(); });
  formats.forEach(button => button.addEventListener('click', () => {
    selectedFormat = button.dataset.rvBookerFormat;
    formats.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    submit.disabled = false;
    updateSubmitLabel();
  }));
  submit.addEventListener('click', async () => {
    if (!selectedDate || !selectedFormat || !verified) return;
    submit.disabled = true;
    submit.textContent = 'Adding your visit';
    try {
      const response = await fetch(`${root.dataset.cartAddUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(root.dataset.product), quantity: 1, properties: { 'Demo date': selectedDate, 'Tour format': selectedFormat } }] })
      });
      if (!response.ok) throw new Error();
      location.assign(root.dataset.cartUrl);
    } catch {
      submit.disabled = false;
      updateSubmitLabel();
      status.textContent = 'The visit could not be added. Please try again or open the flight experience page.';
    }
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && !panel.hidden) closePanel(); });
  const bookingCalendar = document.querySelector('[data-rvb-root]');
  if (bookingCalendar && 'IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      const visible = entries.some(entry => entry.isIntersecting);
      root.classList.toggle('is-suppressed', visible);
      if (visible && !panel.hidden) closePanel();
    }, { threshold: 0.12 }).observe(bookingCalendar);
  }
  showStep('date');
  render();
  load();
})();
